<template>
    <div class="addaddress-wrap">
        <div class="address-wrap_h3">
            <span>{{!id ? '创建' : '修改'}}创建收货地址</span>
        </div>
        <div class="m-form">
            <el-form ref="form" :model="addressData" label-width="110px">
                <el-form-item label="地址信息：" required >
                    <el-cascader
                        ref="cascaderRef"
                        v-model="addressIds"
                        :options="addressList"
                        @change="handleChange"
                        placeholder="选择省/市/区"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" required >
                    <el-input type="textarea" v-model="addressData.address" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"></el-input>
                </el-form-item>
                <el-form-item label="收货人姓名：" required >
                    <el-input v-model="addressData.name" placeholder="请输入收货人姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号码：" required >
                    <el-input type="text" v-model="addressData.phone" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <div class="m-checkbox">
                    <el-checkbox v-model="defaultAdd">设置为默认收货地址</el-checkbox>
                    <div class="m-btn" @click="saveFun">
                        <span>保存</span>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import addressData from "@/assets/js/address";
import _test from "@/utils/test"
export default {
    data() {
        return {
            id:'',
            defaultAdd:false,
            addressList: addressData,
            addressIds: [],
            addressData: {
                id: 0,
                name: "",
                phone: "",
                province_id: "",
                province_name: "",
                city_id: "",
                city_name: "",
                area_id: "",
                area_name: "",
                address: "",
                if_default: 1,
                moren:1
            },
        };
    },
    created(){
        console.log(this.$route);
        if(this.$route.query.id){
            this.id = this.$route.query.id
            this.getInfoFun()
        }
    },
    watch:{
        defaultAdd(newVal){
            this.addressData.if_default = newVal ? 1 : 0
            this.addressData.moren = newVal ? 1 : 0
        }
    },
    methods: {
        handleChange(e,name) {
            const checkedNode =  this.$refs["cascaderRef"].getCheckedNodes();
            console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
            let nameArr = checkedNode[0].pathLabels
            // console.log(e,name);
            // console.log( this.addressIds);
            // let nameArr = name.split(' / ')
            this.addressData['province_id'] = e[0]
            this.addressData['city_id'] = e[1]
            this.addressData['area_id'] = e[2]

            this.addressData['province_name'] = nameArr[0]
            this.addressData['city_name'] = nameArr[1]
            this.addressData['area_name'] = nameArr[2]
        },
        //获取收货地址
        async getInfoFun(){
            let res = await this.$http.get('userAddress_detail',{id:this.$route.query.id})
            if(res.code == 1){
                for(let i in this.addressData){
                    this.addressData[i] = res.data[i]
                }
                this.addressData.id = this.id
                this.defaultAdd = !!(res.data.if_default == 1)
                this.addressIds = [
                    String(res.data.province_id),
                    String(res.data.city_id),
                    String(res.data.area_id)
                ];
            }
        },
        //保存收货地址
        async saveFun(){
            if(!_test.mobile(this.addressData.phone)){
                this.$message.error('手机号格式错误')
                return false;
            }
            let res = await this.$http.get('userAddress_add',this.addressData)
            if(res.code == 1){
                this.$message.success('保存成功')
                this.$to_back()
            }else{
                this.$message.error(res.message)
            }
        }
    },
};
</script>
<style lang="scss">
.addaddress-wrap {
    .address-wrap_h3 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 20px;
            color: #333333;
        }
    }

    .m-form {
        width: 440px;
        margin-top: 40px;
        .el-cascader{
          width: 100%;
        }
        .m-checkbox{
          padding-left: 110px;
          .m-btn{
              display: flex;
              justify-content: center;
              align-items: center;
              width: 200px;
              height: 50px;
              background: #0073DF;
              font-size: 18px;
              font-weight: 800;
              color: #fff;
              cursor: pointer;
              user-select: none;
              margin-top: 40px;
              &:active{
                  opacity: 0.6;
              }
          }
        }
    }
}
</style>
